// frontend/src/views/Register.vue
<template>
    <v-container>
       <v-row justify="center">
         <v-col cols="12" sm="8" md="5">
           <v-card>
             <v-card-title class="text-h5 text-center pa-4">Kayıt Ol</v-card-title>
             <v-card-text>
                <!-- Display Success Message -->
                <v-alert v-if="successMessage" type="success" dense class="mb-4">
                  {{ successMessage }}
                </v-alert>
                <!-- Display Error Message (Using localError) -->
                <v-alert v-if="localError" type="error" dense dismissible class="mb-4">
                 {{ localError }}
               </v-alert>

               <!-- Hide form on success to prevent re-submission -->
               <v-form @submit.prevent="handleRegister" ref="registerForm" v-if="!successMessage">
                 <v-text-field
                   v-model="formData.username"
                   label="Kullanıcı Adı"
                   required
                   :rules="[rules.required, rules.minLength(3)]"
                   prepend-icon="mdi-account"
                   counter="50"
                 ></v-text-field>
                  <v-text-field
                   v-model="formData.email"
                   label="E-posta Adresi"
                   type="email"
                   required
                   :rules="[rules.required, rules.email]"
                   prepend-icon="mdi-email"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.password"
                   label="Şifre"
                   type="password"
                   required
                   :rules="[rules.required, rules.minLength(6)]"
                   prepend-icon="mdi-lock"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.passwordConfirm"
                   label="Şifre Tekrar"
                   type="password"
                   required
                   :rules="[rules.required, passwordMatch]"
                   prepend-icon="mdi-lock-check"
                 ></v-text-field>
                 <v-text-field
                   v-model="formData.profile_title"
                   label="Mesleki Ünvan (Opsiyonel)"
                   placeholder="Diş Hekimi, Teknisyen, Ortodontist vb."
                   prepend-icon="mdi-briefcase"
                 ></v-text-field>

                 <v-btn
                   type="submit"
                   color="primary"
                   block
                   large
                   class="mt-4"
                   :loading="localLoading"
                   :disabled="localLoading || !!successMessage"
                 >
                   Kayıt Ol
                 </v-btn>
               </v-form>
             </v-card-text>
              <v-card-actions class="justify-center pb-4">
                  <!-- Show login link even after success -->
                  Zaten hesabınız var mı? <v-btn small text color="primary" to="/login" class="pl-1">Giriş Yapın</v-btn>
               </v-card-actions>
           </v-card>
         </v-col>
       </v-row>
     </v-container>
   </template>

   <script>
   // Import mapActions and mapMutations
   import { mapActions, mapMutations, mapGetters } from 'vuex';

   export default {
     name: 'RegisterView',
      data() {
       return {
         formData: {
           username: '',
           email: '',
           password: '',
           passwordConfirm: '',
           profile_title: '',
         },
         rules: {
           required: value => !!value || 'Bu alan zorunludur.',
           minLength: (length) => (value) => (value && value.length >= length) || `En az ${length} karakter olmalı.`,
           email: value => /.+@.+\..+/.test(value) || 'Geçerli bir e-posta adresi girin.',
         },
         // Local state for loading and messages
         localLoading: false,
         localError: null,
         successMessage: null,
       };
     },
      computed: {
       // You can still map global error if you want to display it too,
       // but localError is used for the form-specific error message here.
       ...mapGetters(['error']), // Get global error if needed

       passwordMatch() {
         return () => (this.formData.password === this.formData.passwordConfirm) || 'Şifreler eşleşmiyor.';
       },
     },
      mounted() {
        // Clear any global error from previous pages
        this.CLEAR_ERROR();
      },
     methods: {
        // Map the register action and mutations
        ...mapActions('auth', ['register']),
        ...mapMutations(['SET_LOADING', 'SET_ERROR', 'CLEAR_ERROR']),

        async handleRegister() {
           this.CLEAR_ERROR(); // Clear global error state
           this.localError = null; // Clear local error state
           this.successMessage = null;

           const { valid } = await this.$refs.registerForm.validate();
            if (valid) {
                this.localLoading = true;
                // Optionally set global loading: this.SET_LOADING(true);

               try {
                    const userData = {
                        username: this.formData.username,
                        email: this.formData.email,
                        password: this.formData.password,
                        profile_title: this.formData.profile_title || undefined
                    };

                    // --- Call Vuex Action ---
                    // The action now returns the response object on success
                    const response = await this.register(userData);
                    this.successMessage = response.data.message; // Set success message from action's response
                    // --- End Vuex Action Call ---

               } catch (err) {
                    // The action already commits the error to the Vuex store (this.error)
                    // We can also set a local error if needed for specific display
                    this.localError = this.error || 'Kayıt sırasında bilinmeyen bir hata oluştu.'; // Use global error or fallback
                    console.error("Register component caught error:", err);
               } finally {
                   this.localLoading = false;
                   // Optionally clear global loading: this.SET_LOADING(false);
               }
            }
        }
     }
   }
   </script>
